import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const usePasswordVisibility = (initialState = false) => {
  const { t } = useTranslation();
  const [announcement, setAnnouncement] = useState('');
  const [isVisible, setIsVisible] = useState(initialState);

  const toggle = useCallback(() => {
    setIsVisible((prev) => !prev);
    setAnnouncement(isVisible ? t('R093') : t('R094'));
  }, [isVisible, t]);

  return [isVisible, toggle, announcement, setAnnouncement] as const;
};
